var exports = {
  "kL": "CreateDMBottomSheet.module__container___dm1yWU",
  "XG": "CreateDMBottomSheet.module__scroller___dm1yWU",
  "Qs": "CreateDMBottomSheet.module__content___dm1yWU",
  "h_": "CreateDMBottomSheet.module__description___dm1yWU",
  "ov": "CreateDMBottomSheet.module__friendSelector___dm1yWU",
  "qr": "CreateDMBottomSheet.module__footer___dm1yWU",
  "x7": "CreateDMBottomSheet.module__cancelButton___dm1yWU",
  "Tf": "CreateDMBottomSheet.module__createButton___dm1yWU",
};

module.exports = exports;
